// file: web/src/app/AppShell.tsx
"use client";

import type { ReactNode } from "react";
import { usePathname } from "next/navigation";
import AppBottomNav from "@/components/AppBottomNav";

const HIDE_NAV_PREFIXES = ["/login", "/auth"];
const HIDE_NAV_EXACT = ["/login"];

function shouldHideNav(pathname: string) {
  if (HIDE_NAV_EXACT.includes(pathname)) return true;
  return HIDE_NAV_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

export default function AppShell({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const hideNav = shouldHideNav(pathname);

  if (hideNav) {
    return <>{children}</>;
  }

  return (
    <div className="min-h-dvh bg-slate-950 text-slate-100">
      <main className="pb-[calc(88px+env(safe-area-inset-bottom))]">
        {children}
      </main>
      <AppBottomNav />
    </div>
  );
}